import { gql } from '@/api/utils';
import { default as axios } from '@/api/axios';

export default {
  async checkForDupPet(address) {
    try {
      const query = gql`
        query checkForDuplicatePet($address: UserAddressInput) {
          checkForDuplicatePet(address: $address) {
            id
          }
        }
      `;

      const variables = {
        address,
      };

      const { checkForDuplicatePet: results } = await axios.post('/', {
        query,
        variables,
      });

      return results;
    } catch (error) {
      return Promise.reject({
        message: error.message?.[0]?.message,
        code: error.message?.[0]?.extensions?.code ?? 'unknown',
      });
    }
  },
};
